<template>
  <div>
    <b-button
      icon-left="menu"
      class="PopoverActionsButton"
      @click="() => setIsActive(!isActive)"
    />
    <b-message
      ref="popup"
      v-model="isActive"
      class="PopoverActions"
      title="Choose an Action"
      aria-close-label="Close message"
    >
      <div>
        <a
          href=""
          :disabled="loading"
          data-action-type="ITINERARY_DUPLICATE"
          @click.prevent="handleDuplicate"
        >
          <IconDuplicate class="icon color-8 is-xsmall" />
          Duplicate</a
        >
      </div>

      <div v-if="canDelete">
        <a
          href=""
          :disabled="loading || data.status.id !== 1"
          @click.prevent="handleDelete"
        >
          <IconTrash class="icon color-8 is-xsmall" /> Delete</a
        >
      </div>
      <div>
        <a href="#" :data-feature="featureName.ITINERARY_EXPORT">
          <IconExport class="icon color-8 is-xsmall" /> Export</a
        >
      </div>
    </b-message>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { format } from "date-fns";
import { PATH_INFO } from "@/router/path";
import { DATE_FORMAT_YYYY_MM_DD, FEATURE_NAME } from "@/constants";
// import SetAssigneeModal from "@/components/quotes/SetAssigneeModal.vue";

export default {
  name: "QuotesTableActions",
  components: {
    // SetAssigneeModal
  },
  data() {
    return {
      isActive: false,
      isSetAssigneeModalOpen: false,
      featureName: FEATURE_NAME,
    };
  },
  computed: {
    ...mapGetters({
      loading: "utils/getLoading",
      loadingText: "utils/getLoadingText",
      authData: "auth/getAuthData",
      authConfig: "auth/authConfig",
    }),
    canDelete() {
      const authUser = this.authData.user;
      return this.data.owner?.id === authUser.id;
    },
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    payload: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isActive(newValue) {
      if (newValue) {
        setTimeout(() => {
          document.addEventListener("click", this.handleClickOutside);
        }, 1);
      } else document.removeEventListener("click", this.handleClickOutside);
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    openSetAssigneeModal() {
      this.isSetAssigneeModalOpen = true;
    },
    closeSetAssigneeModal() {
      this.isSetAssigneeModalOpen = false;
    },
    setLoading(value = false) {
      this.$store.dispatch("utils/setLoading", value);
      if (!value) this.setLoadingText("Loading content, please wait...");
    },
    setLoadingText(value = "") {
      this.$store.dispatch("utils/setLoadingText", value);
    },
    async duplicateItinerary(data) {
      const payload = {
        code: data.code,
        uuid: data.id,
        start_date: format(data.start_date, DATE_FORMAT_YYYY_MM_DD),
        name: data.name,
        itinerary_type_id: data.itinerary_type_id,
        onlyDuplicate: true,
      };
      this.setLoading(true);
      this.setIsActive(false);
      const response = await this.$store.dispatch(
        "itinerary/duplicate",
        payload
      );
      this.$buefy.toast.open({
        duration: 5000,
        message: response.message,
        position: "is-top",
        type: "is-success",
      });
      this.$router.push({
        path: PATH_INFO.BASIC_INFO.path,
        query: { itinerary: response.itinerary },
      });
      this.setLoading(false);
    },
    async handleDuplicate() {
      return await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          return await this.duplicateItinerary(this.data);
        },
        functionToExecuteOnFail: async (error) => {
          this.setLoading(false);
          this.$buefy.toast.open({
            duration: 5000,
            message:
              "Error trying to duplicate the itinerary, please try again.",
            position: "is-top",
            type: "is-danger",
          });
          throw error;
        },
      });
    },
    handleDelete() {
      this.setIsActive(false);
      this.$buefy.dialog.confirm({
        title: "Deleting itinerary",
        message:
          "Are you sure you want to <b>delete</b> this itinerary? This action cannot be undone",
        confirmText: "Yes, delete Itinerary",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.setLoading(true);
          this.$store
            .dispatch("itinerary/delete", this.data)
            .then((response) => {
              this.$buefy.toast.open({
                duration: 5000,
                message: response.message,
                position: "is-top",
                type: "is-success",
              });
            })
            .finally(() => this.setLoading(false));
        },
      });
    },
    setIsActive(newValue) {
      this.isActive = newValue;
    },
    handleClickOutside(event) {
      const popup = this.$refs.popup;
      if (this.isActive && popup && !popup.$el.contains(event.target)) {
        this.setIsActive(false);
      }
    },
  },
};
</script>
<style>
.dialog .media {
  align-items: center;
}
</style>
